export { default as Root } from './Avatar';
export type { AvatarProps } from './Avatar';

export { default as Image } from './Image';
export type { AvatarImageProps } from './Image';

export { default as Fallback } from './Fallback';
export type { AvatarFallbackProps } from './Fallback';
